import type { WorkspacesResponse, WorkspaceContextResponse } from '../../../shared/api/models'
import { apiGet, apiPost, apiPut, apiRequest } from './transport'

export async function fetchWorkspaces(signal?: AbortSignal): Promise<WorkspacesResponse> {
  return apiGet<'GET /admin/workspaces'>('/admin/workspaces', signal)
}

export async function fetchWorkspaceContext(signal?: AbortSignal): Promise<WorkspaceContextResponse> {
  return apiGet<'GET /admin/workspace-context'>('/admin/workspace-context', signal)
}

export async function postSelectWorkspace(workspaceId: string, signal?: AbortSignal) {
  return apiPost<'POST /admin/workspaces/select'>('/admin/workspaces/select', { workspaceId }, signal)
}

export async function putDefaultWorkspace(workspaceId: string, signal?: AbortSignal) {
  return apiRequest<'PUT /admin/workspaces/default'>('/admin/workspaces/default', { method: 'PUT', body: { workspaceId }, signal, workspaceBound: false })
}

export async function postCreateWorkspace(title: string, signal?: AbortSignal) {
  return apiPost<'POST /admin/workspaces'>('/admin/workspaces', { title }, signal)
}

export async function putWorkspaceTitle(workspaceId: string, title: string, signal?: AbortSignal) {
  return apiPut<'PUT /admin/workspaces/:workspaceId'>(`/admin/workspaces/${encodeURIComponent(workspaceId)}`, { title }, signal)
}
